const tokenKey = 'rhub_id_token';

export const JwtService = {
  
    get: () => {
        return localStorage.getItem(tokenKey);
    },
  
    set: (token:string) => {
        localStorage.setItem(tokenKey, token);
    },
  
    remove: () => {
         localStorage.removeItem(tokenKey);
    },
};